// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1857af44","453":"454463bd","455":"ed9b16fe"}[chunkId] + ".chunk.js";
};